import { IFIReportType } from '@cims-online/shared'
import { CIMSCollapsePanelOptions } from 'components/CIMSCollapse/types'
import { useProjectSettingsContext } from '../../../../ProjectSettingsContext'
import { useState } from 'react'
import DirtyHeader from '../../components/DirtyHeader'
import EnabledIndicator from '../../components/EnabledIndicator'
import { ControlPointPanelName } from './types'
import ControlPointEditPanel from './components/ControlPointEditPanel'
import ControlPointViewPanel from './components/ControlPointViewPanel'
import { NestedCollapseProps } from '../common'

const useControlPointPanel = (
  collapseProps: NestedCollapseProps
): CIMSCollapsePanelOptions => {
  const {
    controlPointIFISettings: { data },
    canEdit,
  } = useProjectSettingsContext()
  const [dirtyPanels, setDirtyPanels] = useState<ControlPointPanelName[]>([])

  return {
    header: {
      children: (
        <DirtyHeader
          title={IFIReportType.DailyInspectionControlPoint.type}
          isDirty={dirtyPanels.length > 0}
        />
      ),
    },
    key: IFIReportType.DailyInspectionControlPoint.id,
    extra: {
      children: <EnabledIndicator enabled={data?.enabled} />,
    },
    children: canEdit ? (
      <ControlPointEditPanel
        {...{ dirtyPanels, setDirtyPanels, ...collapseProps }}
      />
    ) : (
      <ControlPointViewPanel />
    ),
  }
}

export default useControlPointPanel
